import React, { useRef, useState } from "react";
import { Play } from "lucide-react";
import { MEDIA } from "../../lib/media";
import { VSL_SRC } from "../../i18n/landingVslCopy";

// Premium 16:9 VSL player: gold frame, soft glow, poster + big play button; native controls once playing.
export function VslPlayer({ label, onPlay }) {
  const ref = useRef(null);
  const [started, setStarted] = useState(false);
  const start = () => {
    const v = ref.current; if (!v) return;
    setStarted(true); v.play().catch(() => {}); onPlay?.();
  };
  return (
    <div className="relative mx-auto w-full max-w-4xl" data-testid="v2-vsl">
      <div className="absolute -inset-3 rounded-[2rem] bg-xmas-gold/10 blur-2xl sm:-inset-6" aria-hidden="true" />
      <div className="relative overflow-hidden rounded-2xl border border-xmas-gold/45 bg-black shadow-[0_30px_80px_-20px_rgba(0,0,0,0.8)] ring-1 ring-xmas-gold/20 sm:rounded-3xl">
        <div className="relative aspect-video">
          <video ref={ref} src={VSL_SRC} poster={MEDIA.hero} controls={started} playsInline preload="metadata"
                 className="absolute inset-0 h-full w-full object-cover" data-testid="v2-vsl-video" />
          {!started && (
            <button type="button" onClick={start} aria-label={label} data-testid="v2-vsl-play"
                    className="group absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-t from-xmas-navy/80 via-xmas-navy/20 to-transparent">
              <span className="flex h-16 w-16 items-center justify-center rounded-full border border-xmas-gold/70 bg-xmas-gold text-xmas-navy shadow-[0_0_40px_rgba(212,175,55,0.55)] transition-transform duration-300 group-hover:scale-110 sm:h-24 sm:w-24">
                <Play className="ml-1 h-7 w-7 fill-current sm:h-10 sm:w-10" />
              </span>
              <span className="mt-4 text-xs font-semibold uppercase tracking-[0.3em] text-xmas-champagne sm:text-sm">{label}</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
